<template>
  <svg
    lass="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M12 0.5C5.38326 0.5 0 5.88326 0 12.5C0 19.1167 5.38326 24.5 12 24.5C18.6167 24.5 24 19.1167 24 12.5C24 5.88326 18.6167 0.5 12 0.5ZM18.434 10.2726L10.9876 17.719C10.7543 17.9523 10.431 18.0862 10.1013 18.0862H10.0901C9.75594 18.0833 9.43135 17.9437 9.1994 17.7032L5.46835 13.831C4.98835 13.3336 5.00262 12.5389 5.5 12.0589C5.73481 11.8321 6.04383 11.7076 6.36997 11.7076C6.71323 11.7076 7.03366 11.8435 7.27211 12.0906L10.1174 15.0445L16.6619 8.50026C16.8985 8.26363 17.2132 8.13312 17.5482 8.13312C17.8829 8.13312 18.1976 8.26337 18.4342 8.5C18.9226 8.98882 18.9226 9.78406 18.434 10.2726Z"
      fill="#27A37E"
    />
  </svg>
</template>
